<template>
  <div>
    <div class="seccion-titulo"><i class="bi bi-building me-2"></i>Datos del servicio local</div>
    <div class="row g-3 mb-4">
      <div class="col-md-6">
        <label class="form-label form-label-sm">Ubicación del cliente</label>
        <select class="form-select form-select-sm" v-model="ubicacionSeleccionada">
          <option disabled value="">Selecciona una ubicación</option>
          <option v-for="ubicacion in distritosLocal" :key="ubicacion.id" :value="ubicacion">{{ ubicacion.nombre }}</option>
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label form-label-sm">Tipo de unidad</label>
        <select class="form-select form-select-sm" v-model="unidadSeleccionada">
          <option disabled value="">Selecciona una unidad</option>
          <option v-for="unidad in tipoUnidades" :key="unidad.tipo_unidad" :value="unidad">{{ unidad.tipo_unidad }}</option>
        </select>
      </div>
    </div>

    <button class="btn btn-primary btn-sm" @click="calcularCosto">
      <i class="bi bi-calculator me-1"></i> Calcular Costo
    </button>

    <div v-if="resultado" class="resultado-card mt-4">
      <div class="resultado-row resultado-final">
        <span class="resultado-label"><i class="bi bi-check-circle-fill me-1"></i>Costo estimado (sin IGV)</span>
        <span class="resultado-precio">{{ resultado }}</span>
      </div>
      <div class="resultado-extras">
        <div class="extra-item">
          <i class="bi bi-clock me-1"></i>
          <span>Tiempo al origen:</span>
          <strong>{{ unidadSeleccionada.tiempo_transito }}</strong>
        </div>
        <div class="extra-item">
          <i class="bi bi-clock-history me-1"></i>
          <span>Tiempo al destino:</span>
          <strong>{{ unidadSeleccionada.tiempo_transito }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'MercaderiaLocal',
  data() {
    return {
      distritosLocal: [], tipoUnidades: [],
      ubicacionSeleccionada: {}, unidadSeleccionada: {},
      resultado: ''
    };
  },
  mounted() { this.cargarDistritosLocal(); this.getTipoUnidades(); },
  methods: {
    async cargarDistritosLocal() {
      try { const res = await axios.get('/distritosLocal'); this.distritosLocal = res.data; }
      catch (e) { console.error(e); }
    },
    async getTipoUnidades() {
      try { const res = await axios.get('/tipo-unidades'); this.tipoUnidades = res.data; }
      catch (e) { console.error(e); }
    },
    calcularCosto() {
      this.resultado = `S/ ${this.unidadSeleccionada.costo_emergencia}`;
    }
  }
};
</script>

<style scoped>
.seccion-titulo { font-size: 0.78rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.6px; color: #3f51b5; border-bottom: 2px solid #e8eaf6; padding-bottom: 6px; margin-bottom: 14px; }
.resultado-card { background: linear-gradient(135deg, #e8eaf6 0%, #f5f6ff 100%); border: 1px solid #c5cae9; border-radius: 10px; padding: 16px 20px; }
.resultado-row { display: flex; justify-content: space-between; align-items: center; }
.resultado-final { border-top: 1px solid #c5cae9; padding-top: 10px; margin-bottom: 14px; }
.resultado-label { font-size: 0.85rem; color: #5c6bc0; }
.resultado-precio { font-size: 1.4rem; font-weight: 800; color: #3f51b5; }
.resultado-extras { display: flex; gap: 24px; flex-wrap: wrap; }
.extra-item { font-size: 0.82rem; color: #616161; display: flex; align-items: center; gap: 5px; }
.extra-item strong { color: #37474f; }
</style>
